/* eslint-disable import/no-anonymous-default-export */
import { Ref } from "react";
import { MdOutlineEdit } from "react-icons/md";
import styled from "styled-components";
import tw from "twin.macro";
import { DPButton } from "../common/types";

export default (props: DPButton) => (
  <Button {...props} ref={props.ref as Ref<HTMLButtonElement>}>
    <MdOutlineEdit />
    <span>Edit</span>
  </Button>
);

const Button = styled.button(() => [tw`flex space-x-0.5 items-center`]);